import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';

import Logo from '../components/Logo';

const PropsLoader = ({
  condition,
  children,
  loading,
  reveal,
}) => {
  if (reveal) {
    if (loading) {
      return <Logo medium spin />;
    }
    if (!loading && !condition) {
      return <Col xs={12}><h4>No Record</h4></Col>;
    }
    if (!loading && condition) {
      return children;
    }
  }
  return null;
}

PropsLoader.propTypes = {
  condition: PropTypes.bool,
  children: PropTypes.node,
  loading: PropTypes.bool,
  reveal: PropTypes.bool,
};

PropsLoader.defaultProps = {
  condition: false,
  children: null,
  loading: false,
  reveal: false,
};

export default PropsLoader;



// WEBPACK FOOTER //
// ./src/components/PropsLoader.jsx